import { googletag } from "./loader";
import { data } from "@escapio/shared/state/payload";
import { langId } from "@escapio/shared/l10n/lang-id";

googletag.cmd.push(() => {
	googletag
		.pubads()
		.setTargeting("langId", langId)
		.setTargeting("hotelId", `${data.hotel.id}`);

	googletag.enableServices();
});
